// Local Storage
// keyは予め推測しにくい文字列として登録しておく
// valはcryptoを使って暗号化している
//
// ランダム文字列生成: openssl rand -hex 32
//

/* eslint-disable no-console */

import crypto from 'crypto';

const STORAGE_PASS = 'b1f1fcc041dd4179f8e39e835833ca47a405bb66fbeddc5d543bab2ad8bd831c';
// Stamp holder
const KEY_STAMP_HOLDER = 'ae46956c425ba8419f485a22afa425cad8bc613c1f1d05242d87de3125941d2b';

class LocalStorage {
  constructor() {
    this.storage = window.localStorage;
  }

  static enc(str) {
    const cipher = crypto.createCipher('aes192', STORAGE_PASS);
    let crypted = cipher.update(str, 'utf8', 'hex');
    crypted += cipher.final('hex');
    return crypted;
  }

  static dec(str) {
    const decipher = crypto.createDecipher('aes192', STORAGE_PASS);
    let decrypted = decipher.update(str, 'hex', 'utf8');
    decrypted += decipher.final('utf8');
    return decrypted;
  }

  static hash(data) {
    const hash = crypto.createHash('sha1');
    hash.update(data);
    return hash.digest('hex');
  }

  setItem(key, val) {
    const encVal = LocalStorage.enc(val);
    // console.log('setItem', encVal);
    this.storage.setItem(key, encVal);
  }

  getItem(key) {
    // console.log('getItem', this.storage.getItem(key));
    const val = this.storage.getItem(key);
    return (val) ? LocalStorage.dec(val) : null;
  }

  removeItem(key) {
    this.storage.removeItem(key);
  }

  // Stamp holder
  setStampHolder(holder) {
    this.setItem(KEY_STAMP_HOLDER, JSON.stringify(holder));
  }

  getStampHolder() {
    return JSON.parse(this.getItem(KEY_STAMP_HOLDER));
  }

  removeStampHolder() {
    this.removeItem(KEY_STAMP_HOLDER);
  }
}

export default LocalStorage;
